import { Dialog } from 'primereact/dialog';
import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import { closeModal } from 'reducers/modalReducer';
import Loader from './loader';

const Modal = ({
  component,
  className = '',
  header = () => {},
  footer = () => {},
  showHeader = false,
  closeModal,
  contentClassName,
}) => {
  return (
    <Suspense fallback={<Loader />}>
      {component && (
        <Dialog
          showHeader={showHeader}
          visible={!!component}
          onHide={closeModal}
          resizable={false}
          draggable={false}
          blockScroll
          header={header}
          footer={footer}
          className={className}
          contentClassName={contentClassName}
        >
          {component}
        </Dialog>
      )}
    </Suspense>
  );
};

const mapStateToProps = state => ({
  ...state.modalReducer,
});

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(closeModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
